import React from 'react'
import get from 'lodash/get'

export const caretOrientations = {
  right: 'right',
  down: 'down',
}

const ResultCaret = (props) => {
  // direction caret faces when active
  const activeOrientation = get(props, 'activeOrientation')
  const active = get(props, 'active')
  const rotatedClass =
    activeOrientation === caretOrientations.right
      ? 'rotate-90'
      : 'rotate-neg-90'

  return (
    <div className="text-right">
      {active ? (
        <i
          className={`fas fa-caret-${activeOrientation} cta-orange awesome-caret`}
          style={{ fontSize: 40 }}
        />
      ) : (
        <i
          className={`fas fa-caret-${activeOrientation} awesome-caret ${rotatedClass}`}
          style={{ color: 'lightgray', fontSize: 40 }}
        />
      )}
    </div>
  )
}

export default ResultCaret



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/components/ResultCaret.js